import React from "react";
import {Link} from "react-router-dom";
import imgHero from "../../media/img-hero.jpeg"

function Hero() {
    return (
        <section className="hero-section section-padding home">
            <div className="w-layout-blockcontainer container w-container">
                <div data-w-id="d1e30bfd-48d5-048d-64ff-a0fd1fa659d5" className="content-wrapper home-hero">
                    <div className="content home-hero">
                        <div className="top-content">
                            <div className="title">
                                <h1 className="display-heading-1 label">GeoLight</h1>
                                <p className="section-subtitle w-full" style={{ textAlign: "justify" }}>
                                    is an interactive, AI-driven platform designed for real-time mine waste dam management,
                                    built by mine waste engineers for engineers in the field. It enhances safety and mitigates
                                    risk by transforming complex data into clear, actionable insights through dynamic, on-the-go
                                    dashboards. The platform uses advanced AI tools to analyze pore pressure, phreatic levels,
                                    displacements, and other site-specific indicators, enabling proactive decision-making and
                                    early warning capabilities. With GeoLight, engineers gain a powerful, intuitive solution
                                    tailored to the unique challenges of dam monitoring and management.
                                </p>
                            </div>
                            <div className="buttons">
                                <Link id="w-node-_44d97935-8837-04de-0463-fd585f95030e-5f95030e" to="/contact"
                                   className="button bg-theme-color-01 w-inline-block">
                                    <p className="button-text">Get in touch</p>
                                </Link>
                                <Link id="w-node-a7fa2e15-3961-4ff9-f25d-ddea95182df9-95182df9" to="/company"
                                   className="button stoke w-inline-block">
                                    <p className="button-text primary">Download our brochure <br/></p>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="image position-relative rounded-lg">
                        <img
                            src={imgHero}
                            loading="lazy"
                            sizes="(max-width: 479px) 92vw, (max-width: 767px) 95vw, (max-width: 991px) 533px, (max-width: 1279px) 53vw, 533px"
                            srcSet={`${imgHero} 500w, ${imgHero} 800w, ${imgHero} 1066w`}
                            alt="" className="pie"/>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero;